import script from "./StakeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StakeForm.vue?vue&type=script&setup=true&lang=js"

import "./StakeForm.vue?vue&type=style&index=0&id=662d6989&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662d6989"]])

export default __exports__